/**
 * Interceptador Global de Rede Nativo (XMLHttpRequest e Fetch).
 *
 * Garante que TODAS as requisições HTTP da aplicação — inclusive as feitas por
 * bibliotecas instaladas (como asap-upload, asap-crud, plugins legados ou uploads diretos) —
 * herdem automaticamente o cabeçalho 'X-Device-Context: asap_authorized_access'
 * ao se comunicarem com a API da ASAP, evitando o erro 403 Forbidden e sem disparar erros de CORS.
 */

function isLocalhostEnv(): boolean {
  return typeof window !== 'undefined' &&
    (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');
}

function rewriteLocalApiUrl(url: string): string {
  if (!url || !isLocalhostEnv()) {
    return url;
  }
  return url.replace(/^https?:\/\/(api\.tecnologiaasap\.com\.br|apiv3\.plataformaasap\.com\.br)/i, 'http://127.0.0.1:8000');
}

function isAsapApiUrl(url: string): boolean {
  if (!url) {
    return false;
  }
  return (
    url.indexOf('tecnologiaasap.com.br') !== -1 ||
    url.indexOf('plataformaasap.com.br') !== -1 ||
    url.indexOf('127.0.0.1:8000') !== -1 ||
    url.indexOf('localhost:8000') !== -1 ||
    url.indexOf('/api/') !== -1
  );
}

if (typeof window !== 'undefined' && isLocalhostEnv()) {
  try {
    sessionStorage.setItem('apiURL', 'http://127.0.0.1:8000');
    localStorage.setItem('apiURL', 'http://127.0.0.1:8000');
  } catch (e) {}
}

// 1. Interceptação global de XMLHttpRequest (utilizado por bibliotecas e componentes de upload como asap-upload)
if (typeof window !== 'undefined' && (window as any).XMLHttpRequest) {
  const xhrProto = (window as any).XMLHttpRequest.prototype;
  const originalOpen = xhrProto.open;
  const originalSend = xhrProto.send;

  xhrProto.open = function(method: string, url: string) {
    const targetUrl = rewriteLocalApiUrl(url);
    this._asapRequestUrl = targetUrl;
    const args = Array.prototype.slice.call(arguments);
    args[1] = targetUrl;
    return originalOpen.apply(this, args);
  };

  xhrProto.send = function() {
    try {
      const url = this._asapRequestUrl || '';
      if (isAsapApiUrl(url)) {
        this.setRequestHeader('X-Device-Context', 'asap_authorized_access');
      }
    } catch (e) {
      // Ignora caso o estado do XHR já tenha sido fechado ou header já configurado
    }
    return originalSend.apply(this, arguments);
  };
}

// 2. Interceptação global de window.fetch (para bibliotecas que utilizam Fetch API nativa)
if (typeof window !== 'undefined' && (window as any).fetch) {
  const originalFetch = (window as any).fetch;
  (window as any).fetch = function(input: any, init: any) {
    init = init || {};
    if (typeof input === 'string') {
      input = rewriteLocalApiUrl(input);
    }
    const url = typeof input === 'string' ? input : (input && input.url ? input.url : '');

    if (isAsapApiUrl(url)) {
      if (!init.headers) {
        init.headers = {};
      }

      if (typeof Headers !== 'undefined' && init.headers instanceof Headers) {
        init.headers.set('X-Device-Context', 'asap_authorized_access');
      } else if (Array.isArray(init.headers)) {
        init.headers.push(['X-Device-Context', 'asap_authorized_access']);
      } else {
        init.headers['X-Device-Context'] = 'asap_authorized_access';
      }
    }

    return originalFetch.call(this, input, init);
  };
}

console.log('[Security] Interceptador global nativo de rede ativado para todas as bibliotecas.');
